import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { useThemeContext } from '@aave/aave-ui-kit';

import KlapLoader from '../../../images/klap-loader.svg';
import messages from './messages';
import staticStyles from './style';
import KlipView from '../KlipView';

interface PreloaderProps {
  withText?: boolean;
  caption?: string;
  subCaption?: string;
  subDescription?: string;
  smallSize?: boolean;
  forwardRef?: React.Ref<any>;
  withBackground?: boolean;
  showQRCode?: boolean;
  goBack?: () => void;
}

export default function Preloader({
  withText,
  caption,
  subCaption,
  subDescription,
  smallSize,
  forwardRef,
  withBackground,
  showQRCode,
  goBack,
}: PreloaderProps) {
  const intl = useIntl();
  const { currentTheme } = useThemeContext();
  return (
    <div
      className={classNames('Preloader', {
        PreloaderSmall: smallSize,
        Preloader__withBackground: withBackground,
      })}
      ref={forwardRef}
    >
      <KlipView showX showQRCode={showQRCode || false} goBack={goBack!} />
      {withText && (
        <div className="Preloader__text">
          <h4>{intl.formatMessage(messages.caption)}</h4>
          <p>{intl.formatMessage(messages.description)}</p>
        </div>
      )}

      {!!caption && (
        <div className="Preloader__text">
          <h4>{caption}</h4>
        </div>
      )}

      {!showQRCode && (
        <img className="Preloader__klap_loader" src={KlapLoader} alt={'Klap Loader'} />
      )}

      {!!subCaption && !!subDescription && (
        <div className="Preloader__sub-text">
          <h4>{subCaption}</h4>
          <p>{subDescription}</p>
        </div>
      )}

      <style jsx={true} global={true}>
        {staticStyles}
      </style>
      <style jsx={true} global={true}>{`
        .Preloader {
          &__withBackground {
            background: #fff;
          }

          &__text {
            h4 {
              color: ${currentTheme.primary.hex};
            }
            p {
              color: #000;
            }
          }

          &__dot {
            background: ${currentTheme.secondary.hex};

            &:nth-child(1) {
              animation: animation 3s linear infinite 0s;
            }
            &:nth-child(2) {
              animation: animation 3s linear infinite 0.15s;
            }
            &:nth-child(3) {
              animation: animation 3s linear infinite 0.3s;
            }
            &:nth-child(4) {
              animation: animation 3s linear infinite 0.45s;
            }
          }

          &__sub-text {
            h4 {
              color: ${currentTheme.primary.hex};
            }
            p {
              color: ${currentTheme.textDarkBlue.hex};
            }
          }
        }

        @keyframes animation {
          0% {
            opacity: 0;
            transform: scale(0.5);
            background: ${currentTheme.secondary.hex};
          }
          25% {
            opacity: 1;
            transform: scale(1.25);
            background: ${currentTheme.primary.hex};
          }
          50% {
            opacity: 0;
            transform: scale(0.5);
            background: ${currentTheme.secondary.hex};
          }
          75% {
            opacity: 1;
            transform: scale(1.25);
            background: ${currentTheme.primary.hex};
          }
          100% {
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
}
